module.exports = {
  IMAGE_ENDPOINT: "/api/analyse",
};
